import React from 'react';
import TranslationPopup from '../../../hooks/TranslationPopup';
import PublishPopup from '../../../components/PublishPopup';
import EditorialChangePopup from '../../../components/EditorialChangePopup';
import ContentChangePopup from '../../../components/ContentChangePopup';
import MoveNodePopup from '../../../components/MoveNodePopup';
import VersionPopup from '../../../components/VersionPopup';
import VersionPopupView from '../../../components/VersionPopupView';
import EditScheduledPublishingModal from '../../../components/EditScheduledPublishingModal';
import RequestChangeModal from '../../../components/RequestChangeModal';

const MapLevelModals = ({
  activeMode,
  showTranslationPopup,
  setShowTranslationPopup,
  translationDefaults,
  selectedNode,
  handlers,
  supportedLanguages,
  showPublishPopup,
  setShowPublishPopup,
  revisionresponse,
  processDefaultlanguage_id,
  showEditorialPopup,
  setShowEditorialPopup,
  showContentPopup,
  setShowContentPopup,
  showMovePopup,
  setShowMovePopup,
  handleMoveConfirm,
  processId,
  currentParentId,
  currentLevel,
  LoginUser,
  showVersionPopup,
  setShowVersionPopup,
  versionPopupPayload,
  setversionPopupPayload,
  OriginalDefaultlanguge_id,
  contactInfo,
  revisionInfo,
  assignedUsers,
  editScheduledModalOpen,
  setEditScheduledModalOpen,
  pendingApproval,
  handleCancelPublishing,
  handleReschedulePublishing,
  requestChangeModalOpen,
  setRequestChangeModalOpen,
  handleContentChangeRequest,
  title,
}) => {
  return (
    <>
      {activeMode === 'edit' && (
        <>
          <TranslationPopup
            isOpen={showTranslationPopup}
            onClose={() => setShowTranslationPopup(false)}
            defaultValues={translationDefaults}
            onSubmit={(values) => {
              handlers.updateNodeTranslations(selectedNode, values);
              setShowTranslationPopup(false);
            }}
            supportedLanguages={supportedLanguages}
          />
          <PublishPopup
            isOpen={showPublishPopup}
            onClose={() => setShowPublishPopup(false)}
            onNext={handlers.handleNext}
            revisionresponse={revisionresponse}
            selectedLanguage={processDefaultlanguage_id}
            supportedLanguages={supportedLanguages}
          />
          <EditorialChangePopup
            isOpen={showEditorialPopup}
            onBack={() => {
              setShowEditorialPopup(false);
              setShowPublishPopup(true);
            }}
            onPublish={handlers.editorialPublish}
          />
          <ContentChangePopup
            isOpen={showContentPopup}
            type={'ProcessMaps'}
            onBack={() => {
              setShowContentPopup(false);
              setShowPublishPopup(true);
            }}
            onStartApproval={handlers.handleContentSubmit}
            revisionresponse={revisionresponse}
            versionPopupPayload={versionPopupPayload}
            supportedLanguages={supportedLanguages}
            selectedLanguage={processDefaultlanguage_id}
          />
          <MoveNodePopup
            isOpen={showMovePopup}
            onClose={() => setShowMovePopup(false)}
            onMove={handleMoveConfirm}
            ProcessId={processId}
            currentParentId={currentParentId}
            processDefaultlanguage_id={processDefaultlanguage_id}
            currentLevel={currentLevel}
            userId={LoginUser?.id}
          />
        </>
      )}

      {showVersionPopup && activeMode === 'edit' && (
        <VersionPopup
          processId={processId}
          currentLevel={currentLevel}
          onClose={() => setShowVersionPopup(false)}
          currentParentId={currentParentId}
          viewVersion={
            handlers.navigateToVersion ||
            ((pid, lvl, v) =>
              (window.location.href = `/process-version/${pid}/${lvl}/${v}/ProcessMap/${LoginUser?.id}/${currentParentId}`))
          }
          LoginUser={LoginUser}
          title={title}
          type="ProcessMaps"
          handleSaveVersionDetails={(p) => {
            setversionPopupPayload(p);
            setShowVersionPopup(false);
          }}
          status={'draft'}
          versionPopupPayload={versionPopupPayload}
          supportedLanguages={supportedLanguages}
          selectedLanguage={processDefaultlanguage_id}
        />
      )}

      {showVersionPopup && activeMode !== 'edit' && (
        <VersionPopupView
          processId={processId}
          currentLevel={currentLevel}
          currentParentId={currentParentId}
          onClose={() => setShowVersionPopup(false)}
          viewVersion={
            handlers.navigateToVersion ||
            ((pid, lvl, v) =>
              (window.location.href = `/process-version/${pid}/${lvl}/${v}/ProcessMap/${LoginUser?.id}/${currentParentId}`))
          }
          LoginUser={LoginUser}
          title={title}
          status={activeMode === 'published' ? 'Published' : 'draft'}
          type={'ProcessMaps'}
          selectedLanguage={processDefaultlanguage_id}
          OriginalDefaultlanguge_id={OriginalDefaultlanguge_id}
          hideVersionTab={activeMode === 'version'}
          contact_info={activeMode === 'version' ? contactInfo : undefined}
          revision_info={activeMode === 'version' ? revisionInfo : undefined}
          assigned_users={activeMode === 'version' ? assignedUsers : undefined}
        />
      )}

      {activeMode === 'draft' && (
        <>
          <EditScheduledPublishingModal
            isOpen={editScheduledModalOpen}
            onClose={() => setEditScheduledModalOpen(false)}
            currentDate={pendingApproval?.approval?.planned_publish_date}
            onCancelPublishing={handleCancelPublishing}
            onReschedulePublishing={handleReschedulePublishing}
          />
          <RequestChangeModal
            isOpen={requestChangeModalOpen}
            onClose={() => setRequestChangeModalOpen(false)}
            onSubmit={handleContentChangeRequest}
          />
        </>
      )}
    </>
  );
};

export default MapLevelModals;
